export default "assets/images/ba48b220f61a6e1028f1854326f43acd.png";